<template>
    <div style="text-align: left">
        <div class="herd">
            <div class="list">销售统计</div>
        </div>

        <div class="content">
            <div class="goods">
                <div>
                    <div class="condition">
                        年级： <div class="block">
                            <el-select v-model="info.grade" clearable placeholder="请选择" @change="emptyClass">
                                <el-option v-for="item in optionsGrade" :key="item.grade" :label="item.grade"
                                    :value="item.grade">
                                </el-option>
                            </el-select>
                        </div>&nbsp;&nbsp;
                        班级： <div class="block">
                            <el-select v-model="info.className" :disabled="info.grade === null ? true : false" clearable
                                @focus="getSchoolClass" placeholder="请选择">
                                <el-option v-for="item in optionsClass" :key="item.className" :label="item.className"
                                    :value="item.className">
                                </el-option>
                            </el-select>
                        </div>&nbsp;&nbsp;
                        &nbsp;&nbsp;
                        学生姓名：<el-input placeholder="请输入学校名称" v-model.trim="info.studentName" class="input-with-select"
                            style="max-width: 200px">
                            <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
                        </el-input>&nbsp;&nbsp;
                        <el-button style="margin-left:20px" type="primary" plain @click="search">搜 索</el-button>
                        <el-button style="margin-left:20px" type="primary" plain @click="reset">重 置</el-button>
                        <!-- <el-button style="margin-left:20px" type="primary" @click="deriveFile" plain>全部导出</el-button> -->
                        <el-button style="margin-left:20px" type="primary" @click="openDeriveFile" plain>全部导出</el-button>
                        <el-button style="margin-left:20px" type="primary" @click="returnPage" plain>返回</el-button>
                    </div>
                    <hr style="margin-top: 20px" />
                </div>
                <br />
            </div>
            <br />
            <!-- <div @click="export2Excel">导出表格</div> -->
            <div class="global-table-box">
                <div id="active-img">
                    <div class="left">
                        <p>订购总数：</p>
                        <span>{{ data.orderTotal }}</span>
                        <template v-for="(item, index) in data.fourSelectModelVos">
                            <p :key="index">{{ item.modelName }}总数：</p>
                            <span :key="item.modelName">{{ item.menswear }}</span>
                        </template>
                        <p>销售总额：</p>
                        <span>{{ data.totalSales }}</span>
                    </div>
                    <!-- <div id="img1"></div>
                    <div id="img2"></div> -->
                </div>
                <div class="size">
                    <p>订购尺寸</p>
                    <table>
                        <tr style="background-color: #f0f0f0;">
                            <td>尺码</td>
                            <template v-for="(item, index) in fourSelectModelRemarkVos">
                                <td :key="index">{{ item.remarkName }}</td>
                            </template>
                        </tr>
                        <template v-for="(item, index) in fourSelectModelVos">
                            <tr :key="index">
                                <td>{{ item.modelName }}</td>
                                <template v-for="(item1, index1) in item.fourSelectModelRemarkVos">
                                    <td :key="index1">{{ item1.menswear }}</td>
                                </template>
                            </tr>
                        </template>
                    </table>
                </div>
                <div class="size">
                    <p>订购明细</p>
                    <el-table :data="list" border style="width: 100%;" tooltip-effect="dark" :cell-style="{}">
                        <el-table-column type="index" width="50" label="#" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column prop="orderTime" label="订购时间" width="270" align="center" header-align="center">
                        </el-table-column>
                        <el-table-column prop="grade" label="年级" align="center" header-align="center" max-width="500px">
                        </el-table-column>
                        <el-table-column prop="className" label="班级" align="center" header-align="center" max-width="500px">
                        </el-table-column>
                        <el-table-column prop="studentName" label="姓名" align="center" header-align="center"
                            max-width="500px">
                        </el-table-column>
                        <el-table-column prop="quantity" label="数量" align="center" header-align="center" max-width="500px">
                        </el-table-column>
                        <el-table-column prop="salesVolume" label="订购金额(元)" width="200" header-align="center"
                            align="center">
                        </el-table-column>
                        <el-table-column prop="goodsModel" label="款式" align="center" header-align="center"
                            max-width="500px">
                        </el-table-column>
                        <el-table-column prop="remark" label="身高/尺寸" width="200" header-align="center" align="center">
                        </el-table-column>

                    </el-table>
                </div>

            </div>
            <div class="block">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="info.pageNum"
                    layout="prev, pager, next, jumper" :total="totalPage" :page-size="10">
                </el-pagination>
            </div>
        </div>





        <!--导出 -->
        <el-dialog title="订单导出" :visible.sync="dialogFormVisibleExpoit" width="400px">
            <el-form :model="infoExpoit"  ref="rulesExpoit" label-width="100px" class="demo-ruleForm">
                <el-form-item label="开始时间">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.startTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"
                        v-model="infoExpoit.endTime" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleExpoit = false">取 消</el-button>
                <el-button type="primary" @click="deriveFile">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from '../utils/request';
import axios from 'axios';
import exportUrl from '../Api/exportUrl'
import * as echarts from 'echarts';
export default {

    data() {
        return {
            exportUrl,
            // 导出弹窗
            dialogFormVisibleExpoit: false,
            // 导出参数
            infoExpoit: {
                startTime: '',
                endTime: ''
            },
            // 查询参数
            info: {
                batchId: '',
                className: null,
                grade: null,
                goodsId: '',
                studentName: '',
                isPage: true,
                pageSize: 10,
                pageNum: 1,
            },
            // 指标数据
            statisticsData: {},
            // 地址
            options: [],
            // 批次列表
            tableData: [],
            // 总条数
            totalPage: 0,
            // 年级
            optionsGrade: [],
            // 班级
            optionsClass: [],
            schoolId: '',
            // 返回数据
            data: {},
            // 尺码
            fourSelectModelRemarkVos: [],
            // 款式
            fourSelectModelVos: [],
            // 数据列表
            list: [],
            // 图表1
            options1: {},
            // 图表2
            options2: {},
        };
    },
    created() {
        this.info.goodsId = this.$route.query.goodsId
        this.info.batchId = this.$route.query.batchId
        this.schoolId = this.$route.query.schoolId
        this.getGoodsDetails()
        this.getSchoolGrade()
    },
    mounted() {

    },

    methods: {
        // 打开导出弹窗
        openDeriveFile(){
            this.infoExpoit.startTime = ''
            this.infoExpoit.endTime = ''
            this.dialogFormVisibleExpoit = true
        },
        // 返回上一页
        returnPage() {
            this.$router.go(-1)
        },
        // 查询商品销售详情
        async getGoodsDetails() {
            const res = await request({
                method: 'POST',
                url: 'admin/statistical/analysis/getStatistical/analysisOfGradeClasses',
                data: this.info
            })
            // console.log(res);
            if (res.code === '200') {
                this.data = res.data
                this.totalPage = res.data && res.data.fourSelectSonList && res.data.fourSelectSonList.total
                this.fourSelectModelRemarkVos = res.data && res.data.fourSelectModelVos[0] && res.data.fourSelectModelVos[0].fourSelectModelRemarkVos
                this.fourSelectModelVos = res.data && res.data.fourSelectModelVos
                this.list = res.data && res.data.fourSelectSonList && res.data.fourSelectSonList.list
                this.chartGeneration(res.data)
            } else {
                this.$message.error(res.message)
            }
        },
        // 条件查询
        search() {
            if (document.getElementById('img1') !== null) {
                document.getElementById('img1').remove();
            }
            if (document.getElementById('img2')) {
                document.getElementById('img2').remove();
            }
            this.info.pageNum = 1
            this.getGoodsDetails()
        },
        // 重置
        reset() {
            this.info.pageNum = 1
            this.info.className = null
            this.info.grade = null
            this.info.studentName = ''
            this.getGoodsDetails()
        },
        // 分页
        handleCurrentChange() {
            this.getGoodsDetails()
        },
        // 详情
        editorChild(val) {
            // this.$router.push({ name: 'statisticsBacthGoods', query: { id: val.id } })
            this.$router.push({ path: '/statisticsBacthGoods', query: { id: val.id } });
        },
        // 计算销售总额
        totalCalculation(item) {
            return ((Number(item.ownGoods) * 100) - (Number(item.transportation) * 100)) / 100
        },
        // 获取学校年级
        async getSchoolGrade() {
            const res = await request({
                method: 'GET',
                url: `admin/student/getGrade?campusId=${this.schoolId}`
            })
            if (res.code === '200') {
                this.optionsGrade = res.data
            }
        },
        // 获取学校班级
        async getSchoolClass() {
            const res = await request({
                method: 'GET',
                url: `admin/student/getClass?grade=${this.info.grade}`
            })
            if (res.code === '200') {
                // console.log(res);
                this.optionsClass = res.data
            }
        },
        // 导出
        deriveFile() {
            this.dialogFormVisibleExpoit = false
            axios({
                method: 'POST',
                url: exportUrl + `statistical/analysis/export/goodsDetails`,
                data:{
                    goodsId: this.info.goodsId,
                    batchId: this.info.batchId,
                    startTime: this.infoExpoit.startTime,
                    endTime: this.infoExpoit.endTime
                },
                headers: {
                    'Authorization': 'Bearer ' + sessionStorage.getItem('authorization'),
                    'Content-Type': 'application/json;charset=utf-8'
                },
                // data: {
                //     batchId: this.info.batchId,
                //     goodsId: this.info.goodsId,
                // },
                responseType: 'blob'
            }).then((res) => {
                // console.log(res);
                // if (res.code === '200') {
                // console.log(res.headers);
                const temp = res.headers['content-disposition'].split(";")[1].split("filename=")[1];
                let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) // res就是接口返回的文件流了
                let objectUrl = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.download = decodeURIComponent(temp)  //后缀名一定要写对，不然会导致文件损坏，打不开
                a.href = objectUrl
                a.click()
                a.remove()
                // }else{
                //     this.$message.error(error.message)
                // }



            }).catch(error => {
                // this.$message.error(error.message)
                console.log(error);
            });
        },
        //生成图表 
        chartGeneration(data) {
            let htmlImg = document.getElementById('active-img')
            data.fourSelectModelVos.forEach((item, index) => {
                let arr = []
                let div = document.createElement("div")
                div.setAttribute('id', `img${index + 1}`)
                div.setAttribute('style', `width:600px;margin-left: 150px`)
                htmlImg.appendChild(div)
                item.fourSelectModelRemarkVos.forEach(val => {
                    let a = { value: val.menswear, name: val.remarkName }
                    arr.push(a)
                })
                let chartDom = document.getElementById(`img${index + 1}`);
                let myChart = echarts.init(chartDom);
                this[`options${index + 1}`] = {
                    title: {
                        text: item.modelName,
                        left: '150px'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left'
                    },
                    series: [
                        {
                            name: item.modelName,
                            type: 'pie',
                            radius: '50%',
                            right: '0',
                            data: arr,
                            labelLine: {
                                normal: {
                                    show: false
                                },
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                                }
                            },
                            label: {
                                normal: {
                                    position: 'inner',
                                    show: false
                                }
                            },
                        }
                    ]
                };
                myChart.setOption(this[`options${index + 1}`]);
            })
        },
        // 清空选中班级
        emptyClass(item) {
            if (item.length === 0) {
                this.info.className = null
                this.info.grade = null
            }
        }
    },

};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
}

.gross-container {
    width: 300px;
    height: 100px;
    background-color: #000;
    text-align: center;
    padding: 20px 0;
    color: #fff;
}

.condition {
    display: flex;
    line-height: 30px;
}

.herd {
    display: flex;
    justify-content: space-between;
}

.block {
    text-align: right;
    background-color: #fff;
}

// .global-table-box{
//     height: 200px;
//     overflow: hidden;
// }

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

#active-img {
    height: 300px;
    // background-color: pink;
    overflow: hidden;
    display: flex;

    .left {
        min-width: 200px;
        margin-top: 10px;
        // background-color: #000;
        text-align: center;

        p {
            margin-bottom: 10px;
        }

        span {
            font-weight: bold;
            font-size: 20px;
            margin-bottom: 10px;
            display: block;
        }
    }

    #img1 {
        width: 600px;
        height: 100%;
        margin-left: 150px;
        // background-color: #fff;
    }

    #img2 {
        width: 600px;
        height: 100%;
        // background-color: #000;
    }

}

.size {
    padding: 0 50px;

    p {
        font-weight: bold;
        margin: 10px 0;
        font-size: 20px;
    }

    table {
        border-collapse: collapse;
    }

    table,
    th,
    td {
        border: 1px solid #e0e0e0;
        text-align: center;
        width: 600px;
        padding: 5px 0;
    }
}
</style>